import moment from "moment"
import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { EJobWorkItemType } from "src/domain/api/jobWorkItem/EJobWorkItemType"
import { IJobWorkItemSlipV2 } from "src/domain/entities"
import { jobWorkItemSlipTransferService } from "src/domain/services/jobWorkItem/slip/jobWorkItemSlipTransferService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"
import { EItemType } from "../EItemType"

interface Props {
	type: EItemType
	slip: IJobWorkItemSlipV2
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const ItemSlipTransferDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	type,
	slip: { id: slipId, jobWorkItem, issueDate },
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleItemSlipTransfer = useCallback(async () => {
		try {
			setIsLoading(true)

			const itemType =
				type === EItemType.INWARD ? EJobWorkItemType.IN : EJobWorkItemType.OUT

			const updatedItemType =
				type === EItemType.INWARD ? EJobWorkItemType.OUT : EJobWorkItemType.IN

			await jobWorkItemSlipTransferService(
				{
					filter: {
						id: slipId,
						jobWorkItemId: jobWorkItem?.id ?? "",
						itemType,
					},
					update: {
						itemType: updatedItemType,
						issueDate: moment(issueDate).format("YYYY-MM-DD"),
					},
				},
				token,
			)
			setIsOpen(false)
			onSuccess?.()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [setIsOpen, token, onSuccess, slipId, type, jobWorkItem, issueDate])

	return (
		<DeleteItemDialog
			title={getHeaderLabel(type)}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleItemSlipTransfer}
			isLoading={isLoading}
			errorMessage={errorMessage}
			actionText="Transfer"
		/>
	)
}

function getHeaderLabel(type: EItemType) {
	switch (type) {
		case EItemType.INWARD:
			return "Transfer In Slip"
		case EItemType.OUTWARD:
			return "Transfer Out Slip"
	}
	return "Transfer Item Slip"
}
